import React, { useEffect, useState } from 'react'
import Select from 'react-select'
import * as Yup from 'yup';
import { useFormik } from "formik";
import { useLocation, useNavigate } from "react-router";
import api from "../../services/api";
import { langoptions, minimumSpendOptions, osOptions, genderOptions, roles, removeCommonLocation } from '../../utils/constants';
import { daysBetween, NEWISODateString, SameDay, formatDateWithTime, DatetoTimestamp, End_date_cpd, ISODateString } from "../../utils/dateFormat";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Navigation } from "swiper";
import PreviewFrameEdit from "../PreviewFrameEdit";
import Stepper from 'react-stepper-horizontal';
import { Toast } from '../../shared/Toast'

export const campCreativeContext2 = React.createContext();

var appCategoryOptions = [
    { value: "0", label: "All", isdisabled: false },
    { value: '3', label: 'Sports', isdisabled: false },
    { value: '1', label: 'News', isdisabled: false },
    { value: '2', label: 'Business', isdisabled: false },
    { value: '4', label: 'Cinema', isdisabled: false },
    { value: '5', label: 'Special', isdisabled: false },
    { value: '6', label: 'Politics', isdisabled: false }
]
const langoptions_preview = ["", "Telugu", "Tamil", "Hindi", "Kannada", "Malayalam", "Marathi", "Bengali", "Gujarati", "", "Odia"]
const appCategoryOptions_preview = ["All", "News", "Business", "Sports", "Cinema", "Special", "Politics"]
const genderOptions_preivew = ["All", "Male", "Female"]
const osOptions_preview = ["All", "Android", "IOS"]




let languageOptions = []

function HiddenTarget() {

    const steps = [
        { title: 'LineItem' },
        { title: 'Targets' },
        { title: 'Dates & Budget' },
        { title: 'Creative Selection' },

    ];
    // const [appCategoryOptions, setappCategoryOptions] = useState([
    //     // { value: "0", label: "All", isdisabled: false },
    //     { value: '1', label: 'News', isdisabled: true },
    //     { value: '2', label: 'Business', isdisabled: true },
    //     { value: '3', label: 'Sports', isdisabled: true },
    //     { value: '4', label: 'Cinema', isdisabled: true },
    //     { value: '5', label: 'Special', isdisabled: true },
    //     { value: '6', label: 'Politics', isdisabled: true }
    // ])
    const [actual_target, setactual_target] = useState({})
    const [selectedlocs, setSelectedlocs] = useState([])
    const navigate = useNavigate()
    const location = useLocation()
    const [stateOptions, setStateOptions] = useState([])
    const [districtOptions, setDistrictOptions] = useState([])
    const [mandalOptions, setMandalOptions] = useState([])
    const [villageOptions, setVillageOptions] = useState([])
    const [constituencyOptions, setConstituencyOptions] = useState([])
    const [action, setAction] = useState('')
    let type = ""
    // const typedef = () => {
    //     if ((location.state.campaign_type === "CPC" || location.state.campaign_type === "CPM")) {
    //         return "Editorial"
    //     }
    //     else {
    //         return "Local"
    //     }
    // }
    // if (location.state)
    //     type = typedef()
    if (location.state.campaign_type === "CPD") {
        let arr = langoptions.filter((lang) => {
            if (lang.value === 1 || lang.value === 2 || lang.value === 10) return true
            else return false
        })
        languageOptions = arr
    }
    else {
        languageOptions = langoptions
    }


    const setfield = async (array, field, temp) => {
        let arr = []
        if (Array.isArray(array) && field !== "state_ids" && field !== "district_ids" && field !== "mandal_ids" && field !== "village_ids" && field !== "constituency_ids")
            array?.map((x) => arr.push({ value: x, label: x }))

        switch (field) {

            case "lang_ids":
                await lang_idsOnchange(arr)
                await onchange(arr, "lang_ids");
                break
            case "state_ids":

                let states = []
                for await (let item of array) {
                    const temp = { value: item, label: `${item.state_name}` }
                    states.push(temp)
                }
                await state_idsOnchange(states, location.state.target.lang_ids)
                onchange(states, "state_ids")
                break
            case "district_ids":
                let districts = []
                for await (let item of array) {
                    const temp = { value: item, label: `${item.dist_name}` }
                    districts.push(temp)
                }
                await district_idsOnchange(districts, location.state.target.lang_ids)
                onchange(districts, "district_ids")
                break
            case "mandal_ids":
                let mandals = []
                for await (let item of array) {
                    const temp = { value: item, label: `${item.mandal_name}` }
                    mandals.push(temp)
                }
                let tempDistricts = []
                for await (let item of temp) {
                    tempDistricts.push(item.dist_id)
                }
                await mandal_idsOnchange(mandals, tempDistricts, location.state.target.lang_ids, false)
                onchange(mandals, "mandal_ids")
                break
            case "village_ids":
                let villages = []
                for await (let item of array) {
                    const temp = { value: item, label: `${item.village}` }
                    villages.push(temp)
                }
                onchange(villages, "village_ids")
                break
            case 'constituency_ids':
                let constituents = []
                for await (let item of array) {
                    const temp = {value: item, label: `${item.const_name}`}
                    constituents.push(temp)
                }
                onchange(constituents, 'constituency_ids')
            default:

        }
    }
    const editaction = async () => {
        const target = location.state.target
        await setfield(target.lang_ids, "lang_ids", [])
        await setfield(target.state_ids, "state_ids", [])
        await setfield(target.district_ids, "district_ids", [])
        await setfield(target.mandal_ids, "mandal_ids", target.district_ids)
        await setfield(target.village_ids, "village_ids", [])
        await setfield(target.constituency_ids, "constituency_ids", [])
    }

    const getvalues = (Array, field) => {
        if (Array.length > 0) {
            switch (field) {
                case "lang_ids":
                    return Array.filter((option) => formik.values.lang_ids.indexOf(option.value) >= 0)
                case "state_ids":
                    let fun = []
                    formik.values.state_ids.map((option) => { fun.push(option.state_id); return null; })
                    return Array.filter((option) => fun.indexOf(option.value.state_id) >= 0)
                case "district_ids":
                    const res1 = []
                    formik.values.district_ids.map((option) => { res1.push(option.dist_id); return null; })
                    return Array.filter((option) => res1.indexOf(option.value.dist_id) >= 0)

                case "mandal_ids":
                    const res2 = []
                    formik.values.mandal_ids.map((option) => { res2.push(option.mandal_id); return null; })
                    return Array.filter((option) => res2.indexOf(option.value.mandal_id) >= 0)
                case "village_ids":
                    const res3 = []
                    formik.values.village_ids.map((option) => { res3.push(option.village_id); return null; })
                    return Array.filter((option) => res3.indexOf(option.value.village_id) >= 0)
                case "constituency_ids":
                    const res4 = []
                    formik.values.constituency_ids.map((option) => { res4.push(option.const_id); return null;})
                    return Array.filter((option) => res4.indexOf(option.value.const_id) >= 0)
                // case "pincodes":
                // return Array.filter((option) => formik.values.pincodes.indexOf(option.value) >= 0)

                default:
                    return []

            }
        } else {
            return [];
        }
    }

    const defaultValue = (options, value) => {
        return options ? options.find((option) => option.value === value) : "";
    };

    const formik = useFormik({
        initialValues: {
            lang_ids: [],
            state_ids: [],
            district_ids: [],
            mandal_ids: [],
            village_ids: [],
            constituency_ids: []
        },
        validationSchema: Yup.object({
            lang_ids: Yup.array().required("Language is required").min(1, "Please select atleast one language"),
            state_ids: Yup.array(),
            district_ids: Yup.array(),
            mandal_ids: Yup.array(),
            village_ids: Yup.array(),
            constituency_ids: Yup.array()
        }),
        onSubmit: async (values) => {
            try {
                // let campAtPosition = await api({
                //     url: '/user/target/getposition',
                //     method: 'POST',
                //     responseType: 'json',
                //     data: {
                //         pos: location.state.campaign_details.position,
                //         data: location.state.actual_target,
                //         start_date: ISODateString(location.state.campaign_details.start_date),
                //         end_date: ISODateString(location.state.campaign_details.end_date),
                //         id: location.state.campaign_details.campaign_id,
                //         position_type: location.state.campaign_details.position_type,
                //         campaign_name: location.state.campaign_details.campaign_name,
                //         dfp: location.state.campaign_details.ad_code ? location.state.campaign_details.ad_code : "",
                //         hidden_target: values,
                //         creative_type: location.state.campaign_details.creative_type,
                //         priority: location.state.campaign_details.priority
                //     }
                // })
                // if(campAtPosition.data !== ''){
                //     Toast("error", `${campAtPosition.data} already exists in that position`)
                //     return
                // }
            if (action === "Add"){
                const result = await api({
                    url: '/user/target/postHiddenTarget',
                    method: 'POST',
                    responseType: 'json',
                    data: {campaign_id: location.state.campaign_details.campaign_id, ...values}
                })
                if(result.code === 200)
                    navigate("/home/lineitems")
            }
            if(action === "Edit"){
                let res1 = await api({
                    url: `/user/target/editHiddenTarget`,
                    method: "PUT",
                    responseType: "json",
                    data: { hidden_target_id: location.state.target.hidden_target_id, campaign_id: location.state.campaign_details.campaign_id, ...values}
                  })
                  if(res1.code === 200)
                    navigate("/home/lineitems")
            }
            else{

            }
        } catch (error) {
                
        }

        }

    })
    // const back = async () => {
    //     let result = { ...formik.values, locations: [...selectedlocs] }
    //     if (location?.state?.target?.target_id)
    //         result.target_id = location?.state?.target?.target_id
    //     let target_preview = await get_preview_target_data(formik.values)
    //     navigate("/home/lineitems/start",
    //         { state: { ...location.state, target: result, target_preview: target_preview } }
    //     )
    // }
    useEffect(() => {
        if (localStorage.getItem("role") !== roles.ops)
            navigate("/pagenotfound")
        setAction(location?.state?.action)
        if (location?.state?.target) {
            editaction()
            const temp = location.state.target.locations
            setTimeout(() => setSelectedlocs(temp), 0)
        }
        // if(location?.state?.campaign_details.campaign_id){
        //     setlogspreview(location?.state?.campaign_details.campaign_id)
        // }
    }, [])
    // const removeCommonLocation = (lang_ids, state_ids, district_ids, mandal_ids, village_ids, exclude) => {
    //     return new Promise((resolve, reject) => {
    //         try {
    //             let mandalRes = [], districtRes = [], statesRes = [], villageRes = [], mandaldum = [], districtdum = [], statedum = [], langdum = [];
    //             let ex_villages = [], ex_mandals = [], ex_districts = [], states = [], mandalsinlist = [], districtinlist = [], statesinlist = [], villagesinlist = [];
    //             if (mandal_ids.length) mandalsinlist = mandal_ids.map(j => +j.mandal_id);
    //             if (district_ids.length) districtinlist = district_ids.map(j => +j.dist_id);
    //             if (state_ids.length) statesinlist = state_ids.map(j => +j.state_id);
    //             if (village_ids.length) villagesinlist = village_ids.map(j => +j.village_id)
    //             if (village_ids.length) mandaldum = village_ids.map(j => +j.mandal_id)
    //             if (mandal_ids.length) districtdum = mandal_ids.map(j => +j.dist_id)
    //             if (district_ids) statedum = district_ids.map(j => +j.state_id)
    //             if (state_ids) langdum = state_ids.map(j => +j.lang_id)
    //             // console.log(villageRes, "{{{{{{{{{{{{{{{{{{{{", village_ids.map(j => +j.village_id), lang_ids, state_ids, district_ids, mandal_ids, village_ids, "++++++++++++++")
    //             if (exclude) {
    //                 if (village_ids.length) {
    //                     ex_villages = villagesinlist
    //                     mandalRes = mandaldum
    //                     villageRes = []
    //                 }
    //                 if (mandal_ids.length) {
    //                     ex_mandals = mandalsinlist.filter(item => !mandaldum.includes(item))
    //                     districtRes = []
    //                     mandal_ids.map((item) => { if (ex_mandals.includes(item.mandal_id)) districtRes.push(+item.dist_id) })
    //                 }
    //                 if (district_ids.length) {
    //                     ex_districts = districtinlist.filter(item => !districtdum.includes(+item))
    //                     // statesRes = []
    //                     // district_ids.map((item) => { if (ex_districts.includes(+item.dist_id)) statesRes.push(+item.state_id) })
    //                     // statesRes = [...new Set([...statesRes,...statesinlist])]

    //                 }
    //                 statesRes = statesinlist
    //             }
    //             else {
    //                 villageRes = villagesinlist
    //                 statesRes = statesinlist.filter(item => !statedum.includes(item))
    //                 mandalRes = mandalsinlist.filter(item => !mandaldum.includes(item))
    //                 districtRes = districtinlist.filter(item => !districtdum.includes(item))
    //             }
    //             lang_ids = lang_ids.filter(item => !langdum.includes(item))

    //             statesRes = Array.from(new Set(statesRes))
    //             districtRes = Array.from(new Set(districtRes))
    //             mandalRes = Array.from(new Set(mandalRes))
    //             villageRes = Array.from(new Set(villageRes))
    //             ex_districts = Array.from(new Set(ex_districts))
    //             ex_mandals = Array.from(new Set(ex_mandals))
    //             ex_villages = Array.from(new Set(ex_villages))
    //             // if (village_ids.length)
    //             //   villages = village_ids.filter(item => !mandalRes.includes(+item.mandal_id)).map(item => +item.village_id);
    //             // if (mandal_ids.length)
    //             //   mandals = mandal_ids.filter(item => !districtRes.includes(+item.dist_id)).map(item => +item.mandal_id);
    //             // if (district_ids.length)
    //             //   districts = district_ids.filter(item => !statesRes.includes(+item.state_id)).map(item => +item.dist_id);
    //             // if (state_ids.length)
    //             //   states = state_ids.filter(item => {
    //             //     if (lang_ids.includes(+item.lang_id)) {
    //             //       let index = lang_ids.findIndex(j => j === +item.lang_id);
    //             //       lang_ids.splice(index, 1)
    //             //       return true
    //             //     }
    //             //     return false
    //             //   }).map(j => +j.state_id);
    //             return resolve({ lang_ids, state_ids: statesRes, district_ids: districtRes, mandal_ids: mandalRes, village_ids: villageRes, ex_villages, ex_mandals, ex_districts })
    //         } catch (error) {
    //             console.error(error);
    //         }
    //     })
    // }
    const get_preview_target_data = (values) => {

        let lang_ids = values.lang_ids.filter((item, i) => actual_target.lang_ids.includes(item)
        ).map(item => langoptions_preview[item])
        let state_ids = values.state_ids.filter((item, i) => actual_target.state_ids.includes(item.state_id)
        ).map(item => item.state_name)
        let district_ids = values.district_ids.filter((item, i) => actual_target.district_ids.includes(item.dist_id)
        ).map(item => `${item.dist_name}(D), ${item.state_name}(S)`)
        let mandal_ids = values.mandal_ids.filter((item, i) => actual_target.mandal_ids.includes(item.mandal_id)
        ).map(item => `${item.mandal_name}(M), ${item.district_name}(D)`)
        let ex_districts = values.district_ids.filter((item, i) => actual_target.ex_districts.includes(item.dist_id)
        ).map(item => `${item.dist_name}(D), ${item.state_name}(S)`)
        let ex_mandals = values.mandal_ids.filter((item, i) => actual_target.ex_mandals.includes(item.mandal_id)
        ).map(item => `${item.mandal_name}(M), ${item.district_name}(D)`)
        let village_ids = formik.values.village_ids.filter((item, i) => actual_target.village_ids.includes(item.village_id)
        ).map(item => `${item.village}(V), ${item.mandal_name}(M), ${item.district_name}(D), ${item.state_name}(S)`)
        let ex_villages = formik.values.village_ids.filter((item, i) => actual_target.ex_villages.includes(item.village_id)
        ).map(item => `${item.village}(V), ${item.mandal_name}(M), ${item.district_name}(D), ${item.state_name}(S)`)
        let app = values.app.map((item, i) => {

            return `${appCategoryOptions_preview[item]}`
        })
        let minspend = values.minspend
        let min_age = values.min_age
        let max_age = values.max_age
        let os = osOptions_preview[values.os]
        let gender = genderOptions_preivew[values.gender]
        return { lang_ids, state_ids, district_ids, mandal_ids, ex_districts, ex_mandals, village_ids, ex_villages, app, minspend, min_age, max_age, os, gender }
    }
    const actual_target_setting = async () => {
        setactual_target(await removeCommonLocation(formik.values.lang_ids, formik.values.state_ids, formik.values.district_ids, formik.values.mandal_ids, formik.values.village_ids, 0))
    }

    useEffect(() => {
        actual_target_setting()

    }, [formik.values])

    const onchange = (selected, field) => {
        if (selected.length === 0)
            setSelectedlocs([])
        formik.setFieldValue(field, selected ? (selected).map((item) => item.value) : []);

    }
    const lang_idsOnchange = async (selected) => {
        const langs = selected ? (selected).map((item) => item.value) : []
        try {
            let res = await api({
                url: '/location/getStatesByLangId',
                method: 'POST',
                responseType: 'json',
                data: langs
            })
            let states = []
            for await (let item of res.data) {
                const temp = { value: item, label: `${item.state_name}` }
                states.push(temp)
            }
            setStateOptions(states)
            formik.setFieldValue("state_ids", formik.values.state_ids.filter((option) => langs.indexOf(option.lang_id) >= 0))
            formik.setFieldValue("district_ids", formik.values.district_ids.filter((option) => langs.indexOf(option.lang_id) >= 0))
            formik.setFieldValue("constituency_ids", formik.values.constituency_ids.filter((option) => langs.indexOf(option.lang_id) >= 0))
            formik.setFieldValue("mandal_ids", formik.values.mandal_ids.filter((option) => langs.indexOf(option.lang_id) >= 0))
            formik.setFieldValue("village_ids", formik.values.village_ids.filter((option) => langs.indexOf(option.lang_id) >= 0))

        } catch (error) {
            console.error(error);
            if (error.response.status === 401)
                navigate("/")
        }

    }
    const state_idsOnchange = async (selected, langs) => {
        const states = selected ? (selected).map((item) => { if (item.value) return item.value.state_id }) : []
        // const langs = formik.values.lang_ids
        try {
            let res = await api({
                url: '/location/getDistrictsByStateId',
                method: 'POST',
                responseType: 'json',
                data: { states, langs }
            })
            let districts = []
            for await (let item of res.data) {
                const temp = { value: item, label: `${item.dist_name}` }
                districts.push(temp)
            }
            setDistrictOptions(districts)
            let temp = []
            await formik.setFieldValue("district_ids", formik.values.district_ids.filter((option) => { if (states.indexOf(option.state_id) >= 0) { temp.push(option.dist_id); return true } }))
            formik.setFieldValue("constituency_ids", formik.values.constituency_ids.filter((option) => temp.indexOf(parseInt(option.dist_id)) >= 0))
            formik.setFieldValue("mandal_ids", formik.values.mandal_ids.filter((option) => temp.indexOf(parseInt(option.dist_id)) >= 0))
            formik.setFieldValue("village_ids", formik.values.village_ids.filter((option) => temp.indexOf(option.dist_id) >= 0))

        } catch (error) {
            console.error(error);
            if (error.response.status === 401)
                navigate("/")
        }

    }
    const district_idsOnchange = async (selected, langs) => {
        const districts = selected ? (selected).map((item) => { if (item.value) return item.value.dist_id }) : []
        try {
            let res = await api({
                url: '/location/getMandalsnew',
                method: 'POST',
                responseType: 'json',
                data: { districts, langs }
            })
            let mandals = []
            for await (let item of res.data) {
                const temp = { value: item, label: `${item.mandal_name}` }
                mandals.push(temp)
            }
            setMandalOptions(mandals)
            let consties = await api({
                url: `/location/getConstituentsnew`,
                method: 'POST',
                responseType: 'json',
                data: {districts, langs}
            })
            let constituents =[]
            for await(let item of consties.data){
                const temp = { value: item, label: `${item.const_name}`}
                constituents.push(temp)
            }
            setConstituencyOptions(constituents)
            formik.setFieldValue("constituency_ids", formik.values.constituency_ids.filter((option) => districts.indexOf(parseInt(option.dist_id)) >= 0))
            formik.setFieldValue("mandal_ids", formik.values.mandal_ids.filter((option) => districts.indexOf(parseInt(option.dist_id)) >= 0))
            formik.setFieldValue("village_ids", formik.values.village_ids.filter((option) => districts.indexOf(parseInt(option.dist_id)) >= 0))

        } catch (error) {
            console.error(error);
            if (error.response.status === 401)
                navigate("/")
        }

    }
    const mandal_idsOnchange = async (selected, districts, langs, constituency_ids) => {
        const mandals = selected ? (selected).map((item) => { if (item.value) return item.value.mandal_id }) : []
        try {
            //Remove constituency which all mandals are not selected
            if (constituency_ids) {
                const constmandals = mandalOptions.filter(item => formik.values.constituency_ids.map(item => +item.const_id).includes(item.value.const_id))
                let toRemove_consties = constmandals.filter(item => !selected.map(sitem => +sitem.value.mandal_id).includes(item.value.mandal_id)).map(item => item.value.const_id)
                formik.setFieldValue("constituency_ids", constituency_ids.filter(item => !toRemove_consties.includes(item.const_id)))
            }
            let res = await api({
                url: '/location/getVillagesnew',
                method: 'POST',
                responseType: 'json',
                data: { mandals, langs, districts }
            })
            let villages = []
            for await (let item of res.data) {
                const temp = { value: item, label: `${item.village}` }
                villages.push(temp)
            }
            setVillageOptions(villages)
            formik.setFieldValue("village_ids", formik.values.village_ids.filter((option) => mandals.indexOf(option.mandal_id) >= 0))

        } catch (error) {
            console.error(error);
            if (error.response.status === 401)
                navigate("/")
        }

    }
    const constituency_idsOnchange = async (selected) => {
        if(!formik.values.lang_ids.filter(item => item === 1 || item === 2).length){
            formik.setFieldValue("mandals",[])
            formik.setFieldValue("constituency_ids", [])
            setConstituencyOptions([])
        }
        const consties = selected ? selected.map(item => {if(item.value) return +item.value.const_id}) : []
        const langs = selected ? selected.map(item => {if(item.value) return +item.value.lang_id}) : []
        const formMandals = formik.values.mandal_ids.filter(item => !formik.values.constituency_ids.map(item => +item.const_id).includes(+item.const_id)).map(item => +item.mandal_id)
        let constMandals = mandalOptions.filter(item => consties.includes(+item.value.const_id) || formMandals.includes(+item.value.mandal_id)).map(item => item.value)
        formik.setFieldValue('mandal_ids', constMandals)
        const tempMandal_ids = constMandals.map(item => +item.mandal_id)
        // await formik.setFieldValue('village_ids', formik.values.village_ids.filter(item => tempMandal_ids.includes(+item.mandal_id)))
        if(selected.length){
            await formik.setFieldValue('village_ids',[])
            formik.values.village_ids = []
        }
        mandal_idsOnchange(constMandals.map(item => {return {label: item.mandal_name, value: item}}), formik.values.district_ids.map(item => item.dist_id), formik.values.lang_ids, false)
    }
    // const apponchange = (selected) => {
    //     var list = []
    //     var flag = 1
    //     selected.forEach(item => {
    //         if (item.value === "0") {
    //             list = []
    //             list.push("0")
    //             setappCategoryOptions([
    //                 // { value: "0", label: "All", isdisabled: false },
    //                 { value: '1', label: 'News', isdisabled: true },
    //                 { value: '2', label: 'Business', isdisabled: true },
    //                 { value: '3', label: 'Sports', isdisabled: true },
    //                 { value: '4', label: 'Cinema', isdisabled: true },
    //                 { value: '5', label: 'Special', isdisabled: true },
    //                 { value: '6', label: 'Politics', isdisabled: true }
    //             ])
    //             formik.setFieldValue("app", list)
    //             flag = 0
    //             return
    //         }
    //         else {

    //             list.push(item.value)
    //         }
    //     });
    //     if (flag === 1) {
    //         setappCategoryOptions([
    //             // { value: "0", label: "All", isdisabled: false },
    //             { value: '1', label: 'News', isdisabled: false },
    //             { value: '2', label: 'Business', isdisabled: false },
    //             { value: '3', label: 'Sports', isdisabled: false },
    //             { value: '4', label: 'Cinema', isdisabled: false },
    //             { value: '5', label: 'Special', isdisabled: false },
    //             { value: '6', label: 'Politics', isdisabled: false }
    //         ])
    //     }
    //     formik.setFieldValue("app", list)
    //     return
    // }
    const Delete = async()=>{
        try {
            const del_result = await api({
                url: '/user/target/deleteHiddenTarget',
                method: 'POST',
                responseType: 'json',
                data: { campaign_id: location.state.campaign_details.campaign_id, hidden_target_id: location.state.target.hidden_target_id }
            })
        if(del_result.code === 200){
            navigate("/home/lineitems")
        }
        else{
            Toast("error", `Internal server Error`)
        }
         } catch (error) {
            console.error(error)
        }

    }
    // const setlogspreview = async(campaign_id)=>{
    //     let array_result = await api({
    //         url: '/user/target/getHiddenTargetLogs',
    //         method: 'POST',
    //         responseType: 'json',
    //         data: { campaign_id}
    //     })
    // }

    return (
        <div className='campaign-drawer'>
            <div className='title'>
                <legend>Hidden Target</legend>
               <sl-icon name="x" type="button" className="text-danger mt-2" style={{ right: 20, position: "absolute" }} onClick={() => { navigate("/home/lineitems") }}></sl-icon>
            </div>
            <div className='grid grid-cols-2 divide-x mt-3'>
                <div>
                <section className="flex gap-6">
                <div className="basis-7/12 grid gap-6 grid-cols-2">
                    <>{formik.values && <>
                                        <section className="bg-slate-50 py-4 px-6 rounded-lg">
                                            <h6 className="mb-2">Target</h6>
                                            {actual_target.lang_ids?.length > 0 && <div className="flex justify-between mb-2"><label className="text-slate-500">Languages :</label> </div>}
                                            {(Array.isArray(actual_target.lang_ids) && actual_target.lang_ids.length > 0) && formik.values.lang_ids.map((item, i) => {
                                                if (actual_target.lang_ids.includes(item))
                                                    return <span key={i}>{langoptions_preview[item]}</span>
                                            })}
                                            {(Array.isArray(actual_target.state_ids) && actual_target.state_ids.length > 0) && (<div>
                                                <label className="text-slate-500">States : </label>
                                                {formik.values.state_ids.map((item, i) => {
                                                    if (actual_target.state_ids.includes(item.state_id))
                                                        return <p>{item.state_name}</p>
                                                }
                                                )}
                                            </div>)}
                                            {(Array.isArray(actual_target.district_ids) && actual_target.district_ids.length > 0) && <div>
                                                {<label className="text-slate-500">Districts : </label>}
                                                {formik.values.district_ids.map((item, i) => {
                                                    if (actual_target.district_ids.includes(item.dist_id))
                                                        return <p key={i}>{`${item.dist_name}(D), ${item.state_name}(S)`}</p>
                                                }
                                                )}
                                            </div>}
                                            {(Array.isArray(actual_target.ex_districts) && actual_target.ex_districts.length > 0) && <div>
                                                {<label className="text-slate-500">Excluded Districts : </label>}
                                                {formik.values.district_ids.map((item, i) => {
                                                    if (actual_target.ex_districts.includes(item.dist_id))
                                                        return <p key={i}>{`${item.dist_name}(D), ${item.state_name}(S)`}</p>
                                                }
                                                )}
                                            </div>}
                                            {(Array.isArray(actual_target.mandal_ids) && actual_target.mandal_ids.length > 0) && <div>
                                                {<label className="text-slate-500">Mandals : </label>}
                                                {formik.values.mandal_ids.map((item, i) => {
                                                    if (actual_target.mandal_ids.includes(item.mandal_id))
                                                        return <p key={i}>{`${item.mandal_name}(M), ${item.district_name}(D)`}</p>
                                                }
                                                )}
                                            </div>}
                                            {(Array.isArray(actual_target.ex_mandals) && actual_target.ex_mandals.length > 0) && <div>
                                                {<label className="text-slate-500">Excluded Mandals : </label>}
                                                {formik.values.mandal_ids.map((item, i) => {
                                                    if (actual_target.ex_mandals.includes(item.mandal_id))
                                                        return <p key={i}>{`${item.mandal_name}(M), ${item.district_name}(D)`}</p>
                                                }
                                                )}
                                            </div>}
                                            {(Array.isArray(actual_target.village_ids) && actual_target.village_ids.length > 0) && <div>
                                                {<label className="text-slate-500">villages : </label>}
                                                {formik.values.village_ids.map((item, i) => {
                                                    if (actual_target.village_ids.includes(item.village_id))
                                                        return <p key={i}>{`${item.village}(V), ${item.mandal_name}(M), ${item.district_name}(D), ${item.state_name}(S)`}</p>
                                                }
                                                )}
                                            </div>}
                                            {(Array.isArray(actual_target.ex_villages) && actual_target.ex_villages.length > 0) && <div>
                                                {<label className="text-slate-500">Excluded villages : </label>}
                                                {formik.values.village_ids.map((item, i) => {
                                                    if (actual_target.ex_villages.includes(item.village_id))
                                                        return <p key={i}>{`${item.village}(V), ${item.mandal_name}(M), ${item.district_name}(D), ${item.state_name}(S)`}</p>
                                                }
                                                )}
                                            </div>}
                                            {(Array.isArray(formik.values.app) && formik.values.app.length > 0) && <div>
                                                {<label className="text-slate-500">App Category : </label>}
                                                {formik.values.app.map((item, i) => (

                                                    <p key={i}> {appCategoryOptions_preview[item]}</p>
                                                )
                                                )}
                                            </div>}
                                            {(Array.isArray(formik.values.minspend) && formik.values.minspend.length > 0) && <div>
                                                {<label className="text-slate-500">Minimum Spend : </label>}
                                                {formik.values.minspend.map((item, i) => (

                                                    <p key={i}>{item}</p>
                                                )
                                                )}
                                            </div>}
                                            {formik.values ? <div>
                                                {formik.values.min_age > 0 && <p><label className="text-slate-500">Min Age</label> : {formik.values.min_age}</p>}
                                                {formik.values.max_age > 0 && <p><label className="text-slate-500">Max Age</label> : {formik.values.max_age}</p>}
                                                {formik.values.os !== '' && <p><label className="text-slate-500">OS</label> : {osOptions_preview[formik.values.os]}</p>}
                                                {genderOptions_preivew[formik.values.gender] !== null && <p><label className="text-slate-500">Gender</label> : {genderOptions_preivew[formik.values.gender]} </p>}
                                            </div> : null}
                                        </section>
                                    </>
                                    }
                    </>
                </div>
                {/* <div className="basis-7/12 grid gap-6 grid-cols-2">
                    
                </div> */}

                </section>

                </div>
                
                <div>
                    <form onSubmit={formik.handleSubmit} className='contents'>
                        {/* <span className="ml-auto">step:2/4</span> */}

                        <div >
                            <div className="mb-3">
                                <label htmlFor="" className="form-label">Language</label>
                                <span className="text-red-600">*</span>
                                <Select
                                    // class="form-select"
                                    aria-label="Default select example"
                                    name="lang_ids"
                                    placeholder='select language'
                                    onBlur={formik.handleBlur}
                                    value={getvalues(languageOptions, "lang_ids")}
                                    onChange={(selected) => { onchange(selected, "lang_ids"); lang_idsOnchange(selected) }}
                                    options={languageOptions}
                                    isMulti
                                />
                                {formik.errors.lang_ids && (formik.touched.lang_ids) ? <div className="text-red-600">{formik.errors.lang_ids}</div> : null}

                            </div>
                                <div>
                                    <div>
                                        <label htmlFor="" className="form-label">State</label>
                                        <Select
                                            // class="form-select"
                                            aria-label="Default select example"
                                            name="states_ids"
                                            placeholder='Select States'
                                            onBlur={formik.handleBlur}
                                            value={getvalues(stateOptions, "state_ids")}
                                            onChange={(selected) => { onchange(selected, "state_ids"); state_idsOnchange(selected, formik.values.lang_ids) }}
                                            options={stateOptions}
                                            isMulti
                                        />
                                    </div>
                                    <div>
                                        <label htmlFor="" className="form-label">Districts</label>
                                        <Select
                                            // class="form-select"
                                            aria-label="Default select example"
                                            name="district_ids"
                                            placeholder='Select Districts'
                                            onBlur={formik.handleBlur}
                                            value={getvalues(districtOptions, "district_ids")}
                                            onChange={(selected) => { onchange(selected, "district_ids"); district_idsOnchange(selected, formik.values.lang_ids) }}
                                            options={districtOptions}
                                            isMulti
                                        />
                                    </div>
                                    {formik.values.lang_ids.filter(item => item === 1 || item === 2).length ? <div>
                                        <label htmlFor="" className="form-label">Constituency</label>
                                        <Select
                                            // class="form-select"
                                            aria-label="Default select example"
                                            name="constituency_ids"
                                            placeholder='Select Constituency'
                                            onBlur={formik.handleBlur}
                                            value={getvalues(constituencyOptions, "constituency_ids")}
                                            onChange={(selected) => { onchange(selected, "constituency_ids"); constituency_idsOnchange(selected) }}
                                            options={constituencyOptions}
                                            isMulti
                                        />
                                    </div> : null}
                                    <div>
                                        <label htmlFor="" className="form-label">Mandals</label>
                                        <Select
                                            // class="form-select"
                                            aria-label="Default select example"
                                            name="mandal_ids"
                                            placeholder='Select Mandals'
                                            onBlur={formik.handleBlur}
                                            value={getvalues(mandalOptions, "mandal_ids")}
                                            onChange={(selected) => { onchange(selected, "mandal_ids"); mandal_idsOnchange(selected, formik.values.district_ids ? formik.values.district_ids.map((item) => item.dist_id) : [], formik.values.lang_ids, formik.values.constituency_ids) }}
                                            options={mandalOptions}
                                            isMulti
                                        />
                                    </div>
                                    {formik.values.constituency_ids.length === 0 ? <div>
                                        <label htmlFor="" className="form-label">Villages</label>
                                        <Select
                                            // class="form-select"
                                            aria-label="Default select example"
                                            name="village_ids"
                                            placeholder='Select Villages'
                                            onBlur={formik.handleBlur}
                                            value={getvalues(villageOptions, "village_ids")}
                                            onChange={(selected) => { onchange(selected, "village_ids"); }}
                                            options={villageOptions}
                                            isMulti
                                        />
                                    </div> : null}

                                   
                                    </div> 

{/* 
                            <div className="mb-3">
                                <label htmlFor="" className="form-label">OS Type</label>
                                <Select
                                    // class="form-select"
                                    aria-label="Default select example"
                                    name="os"
                                    placeholder='select os'
                                    onBlur={formik.handleBlur}
                                    value={defaultValue(osOptions, formik.values.os)}
                                    onChange={selected => formik.setFieldValue('os', selected.value)}
                                    options={osOptions} />
                                {formik.errors.os && (formik.touched.os) ? <div className="text-red-600">{formik.errors.os}</div> : null}

                            </div>

                            <div className="mb-3">
                                <label htmlFor="" className="form-label">App Category</label>
                                <Select
                                    // class="form-select"
                                    aria-label="Default select example"
                                    name="app"
                                    placeholder='select App Category'
                                    onBlur={formik.handleBlur}
                                    value={getvalues(appCategoryOptions, "app")}
                                    onChange={(selected) => apponchange([selected])}
                                    options={appCategoryOptions}
                                // isOptionDisabled={(option) => option.isdisabled}
                                // isMulti 
                                />
                                {formik.errors.app && (formik.touched.app) ? <div className="text-red-600">{formik.errors.app}</div> : null}

                            </div>


                            <div className="mb-3">
                                <label htmlFor="" className="form-label">Gender</label>
                                <Select
                                    // class="form-select"
                                    aria-label="Default select example"
                                    name="os"
                                    placeholder='select os'
                                    onBlur={formik.handleBlur}
                                    value={defaultValue(genderOptions, formik.values.gender)}
                                    onChange={selected => formik.setFieldValue('gender', selected.value)}
                                    options={genderOptions} />
                                {formik.errors.gender && formik.touched.gender ? <div className="text-red-600">{formik.errors.gender}</div> : null}

                            </div>
                            <div className="mb-3">
                                <label htmlFor="" className="form-label">Minimum age</label>
                                <input
                                    type="number"
                                    className="form-select"
                                    aria-label="Default select example"
                                    name="min_age"
                                    placeholder='Minimum age'
                                    onBlur={formik.handleBlur}
                                    value={formik.values.min_age}
                                    onChange={formik.handleChange}
                                />
                                {formik.errors.min_age && (formik.touched.min_age) ? <div className="text-red-600">{formik.errors.min_age}</div> : null}

                            </div>
                            <div className="mb-3">
                                <label htmlFor="" className="form-label">Maximum age</label>
                                <input
                                    type="number"
                                    className="form-select"
                                    aria-label="Default select example"
                                    name="max_age"
                                    placeholder='Minimum age'
                                    onBlur={formik.handleBlur}
                                    value={formik.values.max_age}
                                    onChange={formik.handleChange}
                                />
                                {formik.errors.max_age && (formik.touched.max_age) ? <div className="text-red-600">{formik.errors.max_age}</div> : null}

                            </div> */}
                            <div className='d-flex gap-2'>
                                {/* <button type="button" className="btn btn-light" onClick={back}>back</button> */}
                                <button type='submit' className="btn btn-primary">Submit</button>
                                {location.state.action === 'Edit' && <button type='button' className="btn btn-danger" onClick={Delete}>Delete</button>}

                            </div>
                        </div>
                    </form>

                </div>
            </div>
        </div>
    )

}

export default HiddenTarget
